"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  containerInfo: {
    title: 'Container Tare Weight Query',
    containerNo: 'Container No.',
    tips_1: ' Warm Tips：',
    tips_2: '(1) Please enter 11-digit container NO, each container No is separated by a comma or a newline character (E.g: SITU1234567, SITU123123, DFSU456456);',
    tips_3: '(2) The results are for reference only. The actual tare weight is based on the container door.',
    containerType: 'Type',
    tareWeight: 'Tare Weight（KG）',
    payloadWeight: 'Maximum load（KG）'
  }
};